/** @jsx jsx */

import { Link, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { MEDIA_MIN_TABLET } from './constants';

const Styles = {
  loginLink: css`
    color: inherit !important;
    text-decoration: none !important;
    transition: all 0.2s ease-in-out !important;
    white-space: nowrap !important;
  `,
  root: (isLoading: boolean) => css`
    align-items: center;
    color: inherit;
    display: ${isLoading ? 'none' : 'flex'};
    justify-content: space-around;
    /* Prefer visibility to display to keep the header height. */
    ${[MEDIA_MIN_TABLET]} {
      justify-content: initial;
      gap: 16px;
    }
  `,
  signUpButton: css`
    display: none;
    ${[MEDIA_MIN_TABLET]} {
      display: inline-block;
    }
  `,
};

type Props = {
  isLoading: boolean;
  onClickLogIn?: () => void;
  onClickSignUp?: () => void;
  urlLogIn: string;
  urlSignUp: string;
};

function AuthButtons({
  isLoading,
  onClickLogIn,
  onClickSignUp,
  urlLogIn,
  urlSignUp,
}: Props) {
  return (
    <nav css={Styles.root(isLoading)}>
      <Link css={Styles.loginLink} href={urlLogIn} onPress={onClickLogIn}>
        <Text color="inherit">Log in</Text>
      </Link>
      <span css={Styles.signUpButton}>
        <Link variant="brand" href={urlSignUp} onPress={onClickSignUp}>
          Sign up
        </Link>
      </span>
    </nav>
  );
}

export default AuthButtons;
